import React from 'react';
import { Controller } from 'react-hook-form';
import { Stack, Box, Text } from '@chakra-ui/react';
import { Radio, RadioGroup } from '../ui/radio';
import { Field } from '../ui/field';

export const CustomRadioGroup = ({ name, control, label, options, defaultValue, direction = "row", ...props }) => {
  return (
    <Field label={label} as="fieldset" mb={4}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <RadioGroup 
            {...field} 
            onValueChange={(e) => field.onChange(e.value)}
            width="100%"
          >
            <Stack direction={direction} spacing={4} wrap="wrap">
              {options.map((opt) => (
                <Radio 
                  key={opt.value} 
                  value={opt.value}
                  cursor="pointer"
                  _checked={{
                    bg: "blue.50",
                    borderColor: "blue.500",
                    color: "blue.700"
                  }}
                  px={4}
                  py={2}
                  borderWidth="1px"
                  borderRadius="md"
                  borderColor="gray.200"
                  transition="all 0.2s"
                  _hover={{ borderColor: "blue.300" }}
                >
                  <Text fontWeight="500">{opt.label}</Text>
                </Radio>
              ))}
            </Stack>
          </RadioGroup>
        )}
      />
    </Field>
  );
};
